import { format, isValid, parse } from "date-fns";

const DATE_FORMAT = "yyyy-MM-dd";
const TIME_FORMAT = "HH:mm:ss";

export function stopDateTimeToDate(date?: string | null, time?: string | null): Date | null {
  if (!date) return null;
  const timePart = time?.slice(0, 8) ?? "00:00:00";
  const parsed = parse(`${date} ${timePart}`, `${DATE_FORMAT} ${TIME_FORMAT}`, new Date());
  return isValid(parsed) ? parsed : null;
}

export function dateToStopFields(date: Date | null): { date: string | null; time: string | null } {
  if (!date || !isValid(date)) {
    return { date: null, time: null };
  }
  return {
    date: format(date, DATE_FORMAT),
    time: format(date, TIME_FORMAT),
  };
}

export function formatStopSummaryDateTime(date?: string | null, time?: string | null): string {
  const parsed = stopDateTimeToDate(date, time);
  if (!parsed) return "";
  return format(parsed, "dd MMM HH:mm");
}

export function formatStopValidationDateTime(date?: string | null, time?: string | null): string {
  const parsed = stopDateTimeToDate(date, time);
  if (!parsed) return "";
  return format(parsed, "dd MMM yyyy, HH:mm");
}
